import React, { Component } from 'react';

import IChatOptions from '../../interfaces/IChatOptions';

export interface IWorkAreaProps {
    options: IChatOptions;
}

class WorkArea extends Component<IWorkAreaProps> {

    public render() {
        return (
            <div>WORK AREA</div>
        );
    }
}

export default WorkArea;
